<div class="custom-filter-area">
    <div class="filters-area">

        <span class="title-txt">Rate Agreement Validation</span>
        <span class="cls-btn" (click)="onCloseBtn()"><mat-icon>close</mat-icon></span>
    </div>
    <div class="import-box-area">
        <span class="title-txt" style="font-weight: 500;">{{this.data.message}}</span>
                
    </div>
    <div class="right-area">
        <button class="red-white-btn" (click)="onConfirm()">Yes</button>
        <button class="white-red-btn" (click)="onCloseBtn()">No</button>
    </div>

</div>